<div class="row survey-list">
    <div *ngIf="!isSelfassessmentTab" class="m-b-25 br-0 head-component">
        <div class="col-10 m-0 p-l-20 for-fixed-component br-0 head-component card">
            <div class="col-9 pl-0 card-body">
                <div class="float-left">
                    <h5 class="m-0 head-main-component">
                        {{ 'lang.userMenu.mySurveys' | translate }}
                    </h5>

                    <div class="filter">
                        <span (click)="currentFilter=surveyFilter.None" [class.filter-active]="!currentFilter">{{'lang.common.fillInSurveys'
                            | translate}}</span>
                        <!-- TODO Survey list tabs -->
                        <!-- <span (click)="currentFilter=surveyFilter.ByAppraisee" [class.filter-active]="currentFilter === surveyFilter.ByAppraisee"> {{'lang.user.estimate.my' | translate}}</span>
                        <span (click)="currentFilter=surveyFilter.ByOthers" [class.filter-active]="currentFilter === surveyFilter.ByOthers"> {{'lang.user.estimate.ofOther' | translate}}</span> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-9 p-l-20">
        <div *ngIf="respondents && respondents.length > 0; else emptyTemplate">
            <div *ngFor="let respondent of filterSurveys()" class="data-questionnaire" (click)="navigateToSurvey(respondent)">
                <div class="card p-0">
                    <div class="card-body">
                        <div class="row mb-2">
                            <div class="col-10" [ngSwitch]="getIsAppraisee(respondent.appraisee)">
                                <div *ngSwitchCase="true">
                                    <span class="caption base-caption">{{'lang.user.appraisee' | translate}}: </span>
                                    <span class="name-user">{{ getAppraiseeName(respondent.appraisee) }}</span>
                                </div>
                                <div *ngSwitchCase="false">
                                    <span class="caption base-caption">{{ 'lang.user.survey' | translate }}: </span>
                                    <span class="name-user">{{ respondent.process.name }} </span>
                                </div>
                            </div>
                            <div class="col-2 completeness">
                                <span>{{ respondent.progress }}</span>%
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-12">
                                <div class="progress">
                                    <div class="progress-bar active" [style.width]="respondent.progress+ '%'"></div>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-8">
                                <div *ngIf="getIsAppraisee(respondent.appraisee)" class="mb-1">
                                    <span class="caption">
                                        {{ 'lang.user.survey' | translate}}:
                                    </span>
                                    <span>
                                        {{ respondent.process.name }}
                                    </span>
                                </div>
                                <div class="mb-1">
                                    <span class="caption">
                                        {{ 'lang.user.duration' | translate}}:
                                    </span>
                                    <span>
                                        {{ respondent.duration }}
                                        {{'lang.common.minuts' | translate}}
                                    </span>
                                </div>
                            </div>
                            <div class="col-4 p-0">
                                <div class="mb-1">
                                    <span class="caption">
                                        {{ 'lang.user.deadline' | translate}}:
                                    </span>
                                    <span>
                                        {{ getLocalizedDate(respondent.endDate) }}
                                    </span>
                                </div>
                                <div class="mb-1">
                                    <span class="caption">
                                        {{ 'lang.user.tileLeft' | translate}}:
                                    </span>
                                    <span [class.short-time]="respondent.timeLeft.days <= surveyShortTimeLeft"
                                        [class.middle-time]="respondent.timeLeft.days > surveyShortTimeLeft && respondent.timeLeft.days <= surveyMiddleTimeLeft"
                                        [class.long-time]="respondent.timeLeft.days > surveyMiddleTimeLeft">
                                        {{ 'lang.user.dateRange' | translate:respondent.timeLeft }}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-8 mb-2 lh-1-2">
                                {{ respondent.description }}
                            </div>
                        </div>
                        <div *ngIf="respondent.isSkippable" class="row mb-3">
                            <div class="col-12">
                                <div class="float-right" (click)="openSkipSurveyModal(skipSurveyModal, respondent); $event.stopPropagation()">
                                    <span class="btn-view">
                                        {{ 'lang.survey.skip' | translate }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-3 pl-0 right-block">
        <div class="card bg-none p-l-10">
            <div class="card-body p-0">
                <div class="row info-panel">
                    <div class="col-1">
                        <i class="mdi mdi-information-outline"></i>
                    </div>
                    <div class="col-10">
                        {{ 'lang.user.userHelp' | translate}}
                    </div>
                </div>
            </div>
        </div>
        <div class="grow-container"></div>
        <app-links-card [links]="'lang.links.documents.my_surveys' | translate"></app-links-card>
    </div>
</div>
<ng-template #emptyTemplate>
    <div class="card b-0 base-shadow-list mb-2">
        <div class="card-body pt-0">
            <div class="row">
                <div class="col-12 no-respondents d-flex align-items-center justify-content-center">
                    <span>
                        {{ 'lang.survey.emptySurvey' | translate }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #skipSurveyModal>
    <div class="card-body">
        <div class="modal-body d-flex flex-column">
            <div class="mdi">
                <div>
                     {{ getSkipSurveyMessage() | translate }}
                </div>
                </div>
            <div class="mt-auto">
                <div class="btn-modal">
                    <span (click)="skipSurvey()">Yes</span>
                    <span (click)="hideModal()">No</span>
                </div>
            </div>
        </div>
    </div>
</ng-template>